import React from "react";
import { speak, stopSpeaking } from "@/lib/speech";
import { useI18n } from "@/contexts/I18nContext";
import { Volume2 } from "lucide-react";

export default function ReadAloud({ text, className = "" }) {
  const { lang, t } = useI18n();
  const handle = () => { stopSpeaking(); speak(text, lang); };
  return (
    <button
      type="button"
      onClick={handle}
      data-testid="read-aloud-btn"
      className={`inline-flex items-center gap-2 rounded-full border-2 border-sarthi-border bg-white px-3 py-2 text-sm font-bold text-sarthi-secondary hover:border-sarthi-primary ${className}`}
      title={t("read_aloud")}
    >
      <Volume2 className="h-4 w-4" /> {t("read_aloud")}
    </button>
  );
}
